import auth from '@/router/auth'
import ContactIndex from '@/components/contacts/Index'
import ContactCreate from '@/components/contacts/Create'
import ContactUpdate from '@/components/contacts/Update'
import ContactShow from '@/components/contacts/Show'

export default [
  {
    path: '/contacts',
    name: 'contacts-index',
    component: ContactIndex,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/contacts/create',
    name: 'contacts-create',
    component: ContactCreate,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/contacts/update/:course_id',
    name: 'contacts-update',
    component: ContactUpdate,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/contacts/show/:course_id',
    name: 'contacts-show',
    component: ContactShow,
    beforeEnter: auth.requireAuth
  }
]



// WEBPACK FOOTER //
// ./src/components/contacts/router.js